import script from "./EPdfViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./EPdfViewer.vue?vue&type=script&lang=ts&setup=true"

import "./EPdfViewer.vue?vue&type=style&index=0&id=45707e57&scoped=true&lang=css"
/* custom blocks */
import block0 from "./EPdfViewer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45707e57"]])

export default __exports__